import { Box, Button, FormHelperText } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import React from "react";
import dayjs from "dayjs";
import PrecedingInvoiceDetailsModal from "./PrecedingInvoiceDetailsModal";

const getPrecedingInvoiceReferenceErrorMessage = (error) => {
  if (!error) return null;

  const refErrors = error.billing_reference;
  return (
    refErrors?.message ||
    refErrors?.id?.message ||
    refErrors?.uuid?.message ||
    refErrors?.issue_date?.message ||
    null
  );
};

export default function AddPrecedingInvoiceDetailsButton({
  error,
  readOnly = false,
  addPrecedingInvoiceDetails,
  getValues,
}) {
  const [modalOpen, setModalOpen] = React.useState(false);
  const ref = getValues?.("billing_reference[0]") || {};
  const precedingInvoiceReferenceErrorMessage = getPrecedingInvoiceReferenceErrorMessage(error);

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  return (
    <div>
      <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
        <Button
          id="preceding-invoice-details"
          variant="contained"
          color={precedingInvoiceReferenceErrorMessage ? "error" : "primary"}
          onClick={handleOpenModal}
        >
          {readOnly ? <VisibilityIcon fontSize="small" sx={{ mr: 1 }} /> : "+ "}
          Preceding Invoice Details
        </Button>
        {precedingInvoiceReferenceErrorMessage && (
          <FormHelperText error sx={{ m: 0 }}>
            {precedingInvoiceReferenceErrorMessage}
          </FormHelperText>
        )}
      </Box>
      <PrecedingInvoiceDetailsModal
        open={modalOpen}
        onClose={handleCloseModal}
        readOnly={readOnly}
        addPrecedingInvoiceDetails={addPrecedingInvoiceDetails}
        initialValue={{
          id: ref.id ?? "",
          uuid: ref.uuid ?? "",
          issue_date: dayjs(ref.issue_date) ?? null,
        }}
      />
    </div>
  );
}
